export const isLocalTestHost = (hostname: string) => hostname === 'localhost' || hostname === 'mac.local';
